import { ResetPasswordForm } from "../_components/Forms/LoginForm/ResetPasswordForm";

const ResetPasswordPage = () => {
    return (
        <>
            <div className="login container">
                <div className="content row">
                    <div className="loginBox">
                        <div className="container-login100">
                            <ResetPasswordForm/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { ResetPasswordPage };